<template>
  <div class="admin-plugin-container">
    <!-- 搜索区域 -->
    <div class="search-bar">
      <!-- 新增按钮 -->
      <div class="action-buttons">
        <el-button
            type="primary"
            @click="handleAdd"
        >新增插件</el-button>
      </div>

      <!-- 插件类型选择 -->
      <el-select
          v-model="searchType"
          placeholder="选择插件类型"
          clearable
          style="width: 150px; margin-left: 10px;"
          @change="handleTypeChange"
      >
        <el-option
            v-for="type in pluginTypes"
            :key="type.id"
            :label="type.name"
            :value="type.id"
        />
      </el-select>

      <!-- 搜索框 -->
      <el-input
          v-model="searchKeyword"
          placeholder="输入插件名称或编码搜索"
          clearable
          style="width: 230px; margin-left: 10px;"
          @clear="clearSearch"
          @keyup.enter="searchProducts"
      />
      <el-button
          style="width: 80px; margin-left: 10px;"
          type="primary"
          @click="searchProducts"
          :loading="searchLoading"
      >搜索</el-button>
    </div>

    <!-- 表格展示区域 -->
    <div class="table-area card">
      <div class="table-header">
        <h3 class="table-title">
          <i class="el-icon-cpu"></i> 插件列表
          <span class="total-count">(共 {{ total }} 条)</span>
        </h3>
        <div class="table-actions">
          <el-button size="small" @click="refreshData">
            <i class="el-icon-refresh"></i> 刷新
          </el-button>
        </div>
      </div>

      <el-table
          :data="products"
          v-loading="loading"
          :cell-style="tableCellStyle"
          :header-cell-style="tableHeaderStyle"
          style="width: 100%"
          border
          stripe
          height="calc(100vh - 270px)"
      >
        <el-table-column v-if="false" prop="id" label="ID" align="center" />
        <el-table-column prop="productCode" label="插件编码" width="160" align="center" />
        <el-table-column prop="name" label="插件名称" width="160" align="center" />
        <el-table-column prop="productTypeName" label="类型" width="120" align="center" />
        <el-table-column prop="version" label="当前版本" width="120" align="center" />

        <el-table-column label="图标" width="90" align="center">
          <template #default="scope">
            <el-image
                v-if="scope.row.iconUrl"
                style="width: 30px; height: 30px; cursor: pointer;"
                :src="scope.row.iconUrl"
                :preview-src-list="[scope.row.iconUrl]"
                preview-teleported
                fit="cover"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon><Picture /></el-icon>
                </div>
              </template>
            </el-image>
            <span v-else style="color: #909399;">暂无icon</span>
          </template>
        </el-table-column>

  <!--      <el-table-column label="单价(元)" width="100" align="center">-->
  <!--        <template #default="scope" >-->
  <!--          <span style="color: #f56c6c; font-weight: 500;">-->
  <!--             {{ scope.row.price != null ? `¥${Number(scope.row.price).toFixed(2)}` : '-' }}-->
  <!--          </span>-->
  <!--        </template>-->
  <!--      </el-table-column>-->

        <el-table-column label="状态" width="90" align="center">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '在售' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="storageUrl" label="文件路径" width="180" align="center">
          <template #default="scope">
            <span v-if="scope.row.storageUrl" style="color: #67c23a;">
              {{ getFileName(scope.row.storageUrl) }}
            </span>
            <span v-else style="color: #909399;">无文件</span>
          </template>
        </el-table-column>

        <el-table-column
            label="下载量"
            width="80"
            align="center">
          <template #default="scope">
            <el-button
                link
                type="warning"
                @click="handleDownloadStats(scope.row)"
                :loading="statsLoading === scope.row.id">
              {{ scope.row.downloadCount || 0 }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column prop="updatedAt" label="更新时间" width="180" align="center" >
          <template #default="scope">
            {{ formatTime(scope.row.updatedAt) }}
          </template>
        </el-table-column>

        <el-table-column label="描述" align="center">
          <template #default="scope">
            <el-tooltip
                effect="light"
                placement="top"
                :content="scope.row.description"
                popper-class="custom-description-tooltip"
            >
              <div class="description-cell">
                {{ scope.row.description }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template #default="scope">
            <el-button
                size="small"
                :type="scope.row.status === 1 ? 'danger' : 'success'"
                @click="handleStatusChange(scope.row)"
            >{{ scope.row.status === 1 ? '下架' : '上架' }}</el-button>

            <el-button
                size="small"
                type="warning"
                @click="handleEdit(scope.row)"
            >修改</el-button>
            <el-button
                size="small"
                type="danger"
                @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
            v-model:current-page="currentPage"
            :page-size="pageSize"
            :total="total"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 添加/修改插件弹窗 -->
    <el-dialog
        :title="dialogTitle"
        v-model="dialogVisible"
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleDialogClose"
    >
      <el-form
          ref="productFormRef"
          :model="productForm"
          :rules="productFormRules"
          label-width="100px"
      >
        <!-- 插件编码 -->
        <el-form-item label="插件编码" prop="productCode">
          <el-autocomplete
              v-model="productForm.productCode"
              :fetch-suggestions="queryProductCodes"
              placeholder="输入或选择插件编码"
              value-key="value"
              @select="handleProductCodeSelect"
              :disabled="isEdit"
          />
        </el-form-item>

        <!-- 插件名称 -->
        <el-form-item label="插件名称" prop="name">
          <el-input
              v-model="productForm.name"
              placeholder="请输入插件名称"
              :disabled="isEdit"
          />
        </el-form-item>

        <!-- 版本号 -->
        <el-form-item label="版本号" prop="version">
          <el-input
              v-model="productForm.version"
              placeholder="请输入版本号"
              :disabled="isEdit"
          />
        </el-form-item>

        <!-- 价格 -->
<!--        <el-form-item label="插件价格" prop="price">-->
<!--          <el-input-number-->
<!--              v-model="productForm.price"-->
<!--              :min="0"-->
<!--              :precision="2"-->
<!--              placeholder="请输入价格"-->
<!--          />-->
<!--        </el-form-item>-->

        <!-- 插件类型 -->
        <el-form-item label="插件类型" prop="productTypeId">
          <el-input
              v-if="isEdit"
              v-model="productForm.productTypeName"
              disabled
              placeholder="插件类型"
          />
          <el-select
              v-else
              v-model="productForm.productTypeId"
              placeholder="请选择插件类型"
          >
            <el-option
                v-for="type in pluginTypes"
                :key="type.id"
                :label="type.name"
                :value="type.id"
            />
          </el-select>
        </el-form-item>

        <!-- 程序文件 -->
        <el-form-item label="程序文件">
          <el-upload
              class="plugin-upload"
              action="#"
              :show-file-list="false"
              :before-upload="beforePluginUpload"
              :http-request="handlePluginUpload"
              accept=".exe,.msi"
              :disabled="pluginUploading || isEdit"
          >
            <el-button size="small" type="primary" :disabled="pluginUploading || isEdit">
              {{ pluginUploading ? '上传中...' : '点击上传' }}
            </el-button>
            <template #tip>
              <div class="el-upload__tip">
                只能上传 .exe 或 .msi 文件，且不超过100MB
              </div>
            </template>
          </el-upload>

          <!-- 上传进度条 -->
          <div v-if="pluginUploading" class="upload-progress">
            <el-progress
                :percentage="uploadProgress"
                :status="uploadProgress === 100 ? 'success' : ''"
                :stroke-width="8"
            />
            <div class="progress-text">
              上传进度: {{ uploadProgress }}%
              <span v-if="uploadProgress === 100" class="success-text">上传完成!</span>
            </div>
          </div>

          <!-- 显示已上传的文件 -->
          <div v-if="productForm.storageUrl && !pluginUploading" class="file-info">
            <el-tag type="success" style="margin-top: 10px;">
              {{ getFileName(productForm.storageUrl) }}
            </el-tag>
            <el-button
                v-if="!isEdit"
                size="mini"
                type="danger"
                @click="removePluginFile"
                :disabled="submitLoading"
            >
              删除
            </el-button>
          </div>

          <div v-else-if="!pluginUploading" class="file-info">
            <span style="color: #909399; font-size: 12px;">暂无程序文件</span>
          </div>
        </el-form-item>

        <!-- 插件icon -->
        <el-form-item label="插件图标">
          <el-upload
              class="icon-upload"
              action="#"
              :show-file-list="false"
              :before-upload="beforeIconUpload"
              :http-request="handleIconUpload"
              accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.ico,.icon"
          >
            <el-button size="small" type="primary">
              点击上传
            </el-button>
            <template #tip>
              <div class="el-upload__tip">
                只能上传 jpg/png/gif/bmp/webp/ico/icon 文件，且不超过10MB
              </div>
            </template>
          </el-upload>

          <!-- 显示已上传的图片 -->
          <div v-if="productForm.iconUrl" class="icon-preview">
            <el-image
                style="width: 80px; height: 60px; margin-top: 10px;"
                :src="productForm.iconUrl"
                fit="cover"
                :preview-src-list="[productForm.iconUrl]"
                preview-teleported
            />
            <div class="icon-actions">
              <el-button size="mini" @click="previewIcon">预览</el-button>
              <el-button size="mini" type="danger" @click="removeIcon" :disabled="submitLoading">删除</el-button>
            </div>
          </div>

          <div v-else class="icon-preview">
            <span style="color: #909399; font-size: 12px;">暂无图标</span>
          </div>
        </el-form-item>

        <!-- 插件描述 -->
        <el-form-item label="插件描述" prop="description">
          <el-input
              v-model="productForm.description"
              type="textarea"
              :rows="3"
              placeholder="请输入插件描述"
          />
        </el-form-item>

        <!-- 状态（仅新增时显示） -->
        <el-form-item label="状态" prop="status" v-if="!isEdit">
          <el-radio-group v-model="productForm.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
            type="primary"
            @click="handleSubmit"
            :loading="submitLoading"
        >确认</el-button>
      </template>
    </el-dialog>

    <!-- 下载统计图表弹窗 -->
    <el-dialog
        :title="`${currentProductName}`"
        v-model="statsDialogVisible"
        width="1200px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleStatsDialogClose">
      <div v-loading="chartLoading" class="chart-container">
        <div ref="chartRef" style="width: 100%; height: 500px;"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import {ref, reactive, onMounted, nextTick, onBeforeUnmount} from 'vue'
import * as echarts from 'echarts';
import {ElMessage, ElMessageBox} from 'element-plus'
import {Picture} from '@element-plus/icons-vue'
import request from '@/utils/request'
import dayjs from "dayjs";

// 响应式数据
const products = ref([])
const loading = ref(false)
const searchKeyword = ref('')
const searchLoading = ref(false)
const searchType = ref('')
const pluginTypes = ref([])
const productCodes = ref([]) // 存储产品编码列表

// 上传进度相关变量
const pluginUploading = ref(false)
const uploadProgress = ref(0)

// 统计相关变量
const statsDialogVisible = ref(false)
const chartLoading = ref(false)
const currentProductName = ref('')
const chartRef = ref(null)
let chartInstance = null

// 分页相关变量
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)

// 插件类型加载状态
const typesLoading = ref(false)

// 弹窗相关数据
const dialogVisible = ref(false)
const dialogTitle = ref('')
const isEdit = ref(false)
const submitLoading = ref(false)
const productFormRef = ref()

// 插件表单数据
const productForm = reactive({
  id: null,
  productCode: '',
  name: '',
  version: '',
  // price: null,
  productTypeId: null,
  productTypeName: '',
  storageUrl: '',
  iconUrl: '',
  description: '',
  status: 1,
  iconFile: null,
  pluginFile: null
})

// 表单验证规则
const productFormRules = {
  productCode: [
    {required: true, message: '请输入插件编码', trigger: 'blur'}
  ],
  name: [
    {required: true, message: '请输入插件名称', trigger: 'blur'}
  ],
  version: [
    {required: true, message: '请输入版本号', trigger: 'blur'}
  ],
  // price: [
  //   {required: true, message: '请输入价格', trigger: 'blur'}
  // ],
  productTypeId: [
    {
      required: true,
      message: '请选择插件类型',
      trigger: 'change',
      validator: (rule, value, callback) => {
        if (!isEdit.value && !value) {
          callback(new Error('请选择插件类型'))
        } else {
          callback()
        }
      }
    }
  ],
  description: [
    {required: true, message: '请输入插件描述', trigger: 'blur'}
  ]
}

// 获取插件类型
const fetchPluginTypes = async () => {
  typesLoading.value = true
  try {
    const response = await request.get('/plugin/types')
    if (response.code === '200') {
      pluginTypes.value = response.data || []
    } else {
      pluginTypes.value = []
    }
  } catch (error) {
    console.error('获取插件类型失败:', error)
    pluginTypes.value = []
  } finally {
    typesLoading.value = false
  }
}

// 获取插件列表
const fetchProducts = async () => {
  loading.value = true
  try {
    const response = await request.get('/plugin/all/products', {
      params: {
        page: currentPage.value,
        size: pageSize.value
      }
    })
    if (response.code === '200') {
      products.value = response.data.list || []
      total.value = response.data.total
    }
  } catch (error) {
    console.error('获取插件信息失败:', error)
  } finally {
    loading.value = false
  }
}

// 获取产品编码列表
const fetchProductCodes = async () => {
  try {
    const response = await request.get('/plugin/product-codes')
    if (response.code === '200') {
      productCodes.value = response.data || []
    } else {
      productCodes.value = []
    }
  } catch (error) {
    console.error('获取产品编码列表失败:', error)
    productCodes.value = []
  }
}

// 产品编码自动补全
const queryProductCodes = (queryString, cb) => {
  const results = queryString
      ? productCodes.value.filter(code =>
          code.toLowerCase().includes(queryString.toLowerCase())
      )
      : productCodes.value

  cb(results.map(code => ({value: code})))
}

// 选择产品编码
const handleProductCodeSelect = (item) => {
  productForm.productCode = item.value
}

// 监听类型变化
const handleTypeChange = () => {
  if (searchType.value) {
    searchProductsByType()
  } else {
    fetchProducts()
  }
}

// 根据类型搜索插件
const searchProductsByType = async () => {
  if (!searchType.value) {
    fetchProducts()
    return
  }

  searchLoading.value = true
  try {
    const response = await request.get('/plugin/search/products/byType', {
      params: {
        typeId: searchType.value,
        keyword: searchKeyword.value,
        page: currentPage.value,
        size: pageSize.value
      }
    })
    if (response.code === '200') {
      products.value = response.data.list || []
      total.value = response.data.total

      if (products.value.length === 0) {
        ElMessage.info('该分类下暂无插件')
      } else {
        ElMessage.success(`找到 ${products.value.length} 个插件`)
      }
    } else {
      ElMessage.error(response.message || '搜索插件失败')
    }
  } catch (error) {
    console.error('按类型搜索插件失败:', error)
    ElMessage.error('搜索插件失败: ' + (error.message || '网络错误'))
  } finally {
    searchLoading.value = false
  }
}

// 清空搜索
const clearSearch = () => {
  searchKeyword.value = ''
  if (searchType.value) {
    searchProductsByType()
  } else {
    fetchProducts()
  }
}

// 搜索插件
const searchProducts = async () => {
  if (searchType.value) {
    await searchProductsByType()
  } else if (!searchKeyword.value.trim()) {
    fetchProducts()
    return
  } else {
    searchLoading.value = true
    try {
      const response = await request.get('/plugin/search/products', {
        params: {
          keyword: searchKeyword.value,
          page: currentPage.value,
          size: pageSize.value
        }
      })
      if (response.code === '200') {
        products.value = response.data.list || []
        total.value = response.data.total
      } else {
        ElMessage.error(response.message || '搜索插件失败')
      }
    } catch (error) {
      console.error('搜索插件失败:', error)
      ElMessage.error('搜索插件失败: ' + (error.message || '网络错误'))
    } finally {
      searchLoading.value = false
    }
  }
}

// 新增插件
const handleAdd = () => {
  dialogTitle.value = '新增插件'
  isEdit.value = false
  Object.assign(productForm, {
    id: null,
    productCode: '',
    name: '',
    version: '',
    // price: null,
    productTypeId: null,
    productTypeName: '',
    storageUrl: '',
    iconUrl: '',
    description: '',
    status: 1,
    iconFile: null,
    pluginFile: null
  })
  dialogVisible.value = true
}

// 修改插件
const handleEdit = (row) => {
  dialogTitle.value = '修改插件'
  isEdit.value = true

  let typeName = row.productTypeName || ''
  if (!typeName && row.productTypeId) {
    const foundType = pluginTypes.value.find(type => {
      return Number(type.id) === Number(row.productTypeId)
    })
    typeName = foundType ? foundType.name : ''
  }

  Object.assign(productForm, {
    id: row.id,
    productCode: row.productCode,
    name: row.name,
    version: row.version,
    // price: row.price,
    productTypeId: row.productTypeId,
    productTypeName: typeName,
    storageUrl: row.storageUrl,
    iconUrl: row.iconUrl,
    description: row.description,
    status: row.status
  })
  dialogVisible.value = true
}

// 删除插件
const handleDelete = async (row) => {
  try {
    await ElMessageBox.confirm(
        `确定要删除插件 "${row.name}" 吗？`,
        '删除确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
    )

    const response = await request.delete(`/plugin/delete/products/${row.id}`)
    if (response.code === '200') {
      ElMessage.success('删除成功')
      fetchProducts()
    } else {
      ElMessage.error(response.message || '删除失败')
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除失败:', error)
      ElMessage.error('删除失败: ' + (error.message || '网络错误'))
    }
  }
}

// 分页变化处理
const handleCurrentChange = (page) => {
  currentPage.value = page
  if (searchType.value) {
    searchProductsByType()
  } else if (searchKeyword.value) {
    searchProducts()
  } else {
    fetchProducts()
  }
}

// 图标上传前的验证
const beforeIconUpload = (file) => {
  const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|ico|icon)$/i.test(file.name);
  const isLt10M = file.size / 1024 / 1024 < 10;

  if (!isImage) {
    ElMessage.error('只能上传图片格式文件 (JPEG, JPG, PNG, GIF, BMP, WEBP, ICO, ICON)!');
    return false;
  }
  if (!isLt10M) {
    ElMessage.error('图片大小不能超过 10MB!');
    return false;
  }
  return true;
}

// 处理图标上传
const handleIconUpload = async (options) => {
  const {file} = options;

  try {
    const formData = new FormData();
    formData.append('file', file);

    if (isEdit.value && productForm.id) {
      const response = await request.post(`/file/upload/icon/${productForm.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.code === '200') {
        productForm.iconUrl = response.data;
        ElMessage.success('图标上传成功');
        fetchProducts();
      } else {
        ElMessage.error(response.message || '图标上传失败');
      }
    } else {
      productForm.iconUrl = URL.createObjectURL(file);
      productForm.iconFile = file;
      ElMessage.success('图标已选择，保存时将一起上传');
    }
  } catch (error) {
    console.error('图标上传失败:', error);
    ElMessage.error('图标上传失败: ' + (error.message || '网络错误'));
  }
}

// 程序文件上传前的验证
const beforePluginUpload = (file) => {
  const isAllowed = /\.(exe|msi)$/i.test(file.name);
  const isLt100M = file.size / 1024 / 1024 < 100;

  if (!isAllowed) {
    ElMessage.error('只能上传 .exe 或 .msi 文件!');
    return false;
  }
  if (!isLt100M) {
    ElMessage.error('文件大小不能超过 100MB!');
    return false;
  }
  return true;
}

// 处理程序文件上传
const handlePluginUpload = async (options) => {
  const {file} = options;

  if (isEdit.value && productForm.id) {
    pluginUploading.value = true;
    uploadProgress.value = 0;

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await request.post(`/file/upload/plugin/${productForm.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            uploadProgress.value = progress;
          }
        }
      });

      if (response.code === '200') {
        productForm.storageUrl = response.data;
        uploadProgress.value = 100;

        setTimeout(() => {
          pluginUploading.value = false;
          ElMessage.success('程序文件上传成功');
        }, 500);
      } else {
        pluginUploading.value = false;
        ElMessage.error(response.message || '程序文件上传失败');
      }
    } catch (error) {
      pluginUploading.value = false;
      console.error('程序文件上传失败:', error);

      if (error.code === 'ECONNABORTED') {
        ElMessage.error('上传超时，请检查网络连接或尝试重新上传');
      } else {
        ElMessage.error('程序文件上传失败: ' + (error.message || '网络错误'));
      }
    }
  } else {
    try {
      productForm.pluginFile = file;
      productForm.storageUrl = file.name;
      ElMessage.success('程序文件已选择，保存时将一起上传');
    } catch (error) {
      console.error('文件处理失败:', error);
      ElMessage.error('文件处理失败: ' + (error.message || '未知错误'));
    }
  }
}

// 预览图标
const previewIcon = () => {
  if (productForm.iconUrl) {
    const img = new Image();
    img.src = productForm.iconUrl;
    const newWindow = window.open('');
    newWindow.document.write(img.outerHTML);
  }
}

// 删除图标
const removeIcon = async () => {
  try {
    if (isEdit.value && productForm.id) {
      await ElMessageBox.confirm('确定要删除图标吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });

      const response = await request.delete(`/file/delete/icon/${productForm.id}`);
      if (response.code === '200') {
        productForm.iconUrl = '';
        ElMessage.success('图标删除成功');
        fetchProducts();
      } else {
        ElMessage.error(response.message || '图标删除失败');
      }
    } else {
      productForm.iconUrl = '';
      productForm.iconFile = null;
      ElMessage.success('图标已移除');
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除图标失败:', error);
      ElMessage.error('删除图标失败: ' + (error.message || '网络错误'));
    }
  }
}

// 删除程序文件
const removePluginFile = async () => {
  try {
    if (isEdit.value && productForm.id) {
      await ElMessageBox.confirm('确定要删除程序文件吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });

      pluginUploading.value = false;
      uploadProgress.value = 0;

      const response = await request.delete(`/file/delete/plugin/${productForm.id}`);
      if (response.code === '200') {
        productForm.storageUrl = '';
        ElMessage.success('程序文件删除成功');
      } else {
        ElMessage.error(response.message || '程序文件删除失败');
      }
    } else {
      productForm.storageUrl = '';
      productForm.pluginFile = null;
      pluginUploading.value = false;
      uploadProgress.value = 0;
      ElMessage.success('程序文件已移除');
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除程序文件失败:', error);
      ElMessage.error('删除程序文件失败: ' + (error.message || '网络错误'));
    }
  }
}

// 获取文件名
const getFileName = (path) => {
  if (!path) return '';
  return path.split('/').pop();
}

// 表单提交
const handleSubmit = async () => {
  if (!productFormRef.value) return

  await productFormRef.value.validate(async (valid) => {
    if (!valid) {
      ElMessage.error('请完善表单信息')
      return
    }

    submitLoading.value = true
    try {
      let response

      if (isEdit.value) {
        // 修改时只提交可修改的字段
        const updateData = {
          id: productForm.id,
          price: productForm.price,
          description: productForm.description
        }
        response = await request.put('/plugin/update/products', updateData)
      } else {
        const productData = {
          productCode: productForm.productCode,
          name: productForm.name,
          version: productForm.version,
          productTypeId: productForm.productTypeId,
          description: productForm.description,
          status: productForm.status
        }

        response = await request.post('/plugin/add/products', productData)

        if (response.code === '200' && response.data) {
          const productId = response.data.id || response.data
          console.log('新增插件成功，产品ID:', productId)

          // 新增成功后，刷新产品编码列表
          await fetchProductCodes()

          if (productForm.iconFile) {
            try {
              const iconFormData = new FormData()
              iconFormData.append('file', productForm.iconFile)
              const iconResponse = await request.post(`/file/upload/icon/${productId}`, iconFormData, {
                headers: {'Content-Type': 'multipart/form-data'}
              })
              if (iconResponse.code !== '200') {
                ElMessage.warning('插件创建成功，但图标上传失败: ' + (iconResponse.message || '未知错误'))
              }
            } catch (iconError) {
              console.error('图标上传失败:', iconError)
              ElMessage.warning('插件创建成功，但图标上传失败')
            }
          }

          if (productForm.pluginFile) {
            try {
              const pluginFormData = new FormData()
              pluginFormData.append('file', productForm.pluginFile)
              const pluginResponse = await request.post(`/file/upload/plugin/${productId}`, pluginFormData, {
                headers: {'Content-Type': 'multipart/form-data'}
              })
              if (pluginResponse.code !== '200') {
                ElMessage.warning('插件创建成功，但程序文件上传失败: ' + (pluginResponse.message || '未知错误'))
              }
            } catch (pluginError) {
              console.error('程序文件上传失败:', pluginError)
              ElMessage.warning('插件创建成功，但程序文件上传失败')
            }
          }
        }
      }

      if (response.code === '200') {
        ElMessage.success(isEdit.value ? '修改成功' : '新增成功')
        dialogVisible.value = false
        fetchProducts()
      } else {
        // 检查是否为唯一性错误（相同插件编号和版本已存在）
        if (response.message && response.data.message.includes('相同插件编号和版本已存在')) {
          // 清空版本号输入框
          productForm.version = ''
          // 提示用户
          ElMessage.error('该插件已存在相同版本，请修改版本号')
        } else {
          ElMessage.error(response.message || (isEdit.value ? '修改失败' : '新增失败'))
        }
      }
    } catch (error) {
      console.error('操作失败:', error)
      // 检查错误信息中是否包含唯一性约束错误
      if (error.message && error.response.data.message.includes('相同插件编号和版本已存在')) {
        productForm.version = ''
        ElMessage.error('该插件已存在相同版本，请修改版本号')
      } else {
        ElMessage.error('操作失败: ' + (error.message || '网络错误'))
      }
    } finally {
      submitLoading.value = false
    }
  })
}

// 弹窗关闭处理
const handleDialogClose = () => {
  productFormRef.value?.clearValidate()
  pluginUploading.value = false;
  uploadProgress.value = 0;

  if (!isEdit.value && !productForm.id) {
    Object.assign(productForm, {
      id: null,
      productCode: '',
      name: '',
      version: '',
      price: null,
      productTypeId: null,
      productTypeName: '',
      storageUrl: '',
      iconUrl: '',
      description: '',
      status: 1
    })
  }
}

// 上下架操作
const handleStatusChange = async (product) => {
  try {
    const newStatus = product.status === 1 ? 0 : 1
    const actionText = newStatus === 1 ? '上架' : '下架'

    await ElMessageBox.confirm(
        `确定要${actionText}插件 "${product.name}" 吗？`,
        `${actionText}确认`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
    )

    const response = await request.put('/plugin/update/products/status', {
      id: product.id,
      status: newStatus
    })
    if (response.code === '200') {
      ElMessage.success(`${actionText}成功`)
      fetchProducts()
    } else {
      ElMessage.error(response.message || `${actionText}失败`)
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('操作失败:', error)
      ElMessage.error('操作失败: ' + (error.message || '网络错误'))
    }
  }
}

// 格式化时间
const formatTime = (time) => {
  if (!time) return '-'
  return dayjs(time).format('YYYY-MM-DD hh:mm:ss')
}

// 统计方法
const handleDownloadStats = async (row) => {
  currentProductName.value = row.name
  statsDialogVisible.value = true
  chartLoading.value = true

  try {
    const response = await request.get(`/plugin/download-stats/${row.id}`)
    if (response.code === '200') {
      nextTick(() => {
        renderChart(response.data.dailyStats)
      })
    } else {
      ElMessage.error(response.message || '获取下载统计失败')
    }
  } catch (error) {
    console.error('获取下载统计失败:', error)
    ElMessage.error('获取下载统计失败: ' + (error.message || '网络错误'))
  } finally {
    chartLoading.value = false
  }
}

// 渲染图表
const renderChart = (dailyStats) => {
  if (!chartRef.value) return

  if (chartInstance) {
    chartInstance.dispose()
  }

  chartInstance = echarts.init(chartRef.value)

  const data = dailyStats.map(item => {
    return [item.download_date, item.download_count]
  })

  const dateList = data.map(function (item) {
    return item[0];
  });
  const valueList = data.map(function (item) {
    return item[1];
  });

  const maxCount = Math.max(...valueList);

  const option = {
    visualMap: [{
      show: false,
      type: 'continuous',
      seriesIndex: 0,
      min: 0,
      max: maxCount,
      inRange: {
        color: ['#99b1da', '#0a2d67']
      }
    }],
    title: {
      left: 'center',
      text: '近45天下载趋势'
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        const data = params[0];
        const originalDate = data.name;
        const date = new Date(originalDate);
        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
        return `${formattedDate}<br/>下载量: ${data.value}`;
      }
    },
    xAxis: {
      type: 'category',
      data: dateList,
      axisLabel: {
        interval: 4
      }
    },
    yAxis: {
      type: 'value'
    },
    series: [{
      type: 'line',
      showSymbol: false,
      data: valueList,
      lineStyle: {
        width: 1
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0,
            color: 'rgb(255,255,255)'
          }, {
            offset: 1,
            color: 'rgb(255,255,255)'
          }]
        }
      }
    }],
    grid: {
      left: '3%',
      right: '4%',
      bottom: '15%',
      top: '15%',
      containLabel: true
    }
  };

  chartInstance.setOption(option)
  window.addEventListener('resize', handleChartResize)
}

// 图表响应式调整
const handleChartResize = () => {
  if (chartInstance) {
    chartInstance.resize()
  }
}

// 关闭统计弹窗
const handleStatsDialogClose = () => {
  window.removeEventListener('resize', handleChartResize)

  if (chartInstance) {
    chartInstance.dispose()
    chartInstance = null
  }

  statsDialogVisible.value = false
  currentProductName.value = ''
}

// 刷新方法
const refreshData = () => {
  currentPage.value = 1
  fetchProducts()
}

// 表格样式方法
const tableCellStyle = ({ row, column, rowIndex, columnIndex }) => {
  // 可以针对特定列设置样式
  if (column.property === 'updatedAt') {
    return {
      color: '#1890ff',
      fontWeight: '500'
    }
  }
  return {}
}

const tableHeaderStyle = ({ row, column, rowIndex, columnIndex }) => {
  return {
    background: '#f8f9fa',
    fontWeight: '600',
    color: '#495057',
    borderBottom: '2px solid #dee2e6'
  }
}

// 生命周期钩子
onMounted(async () => {
  await fetchPluginTypes()
  await fetchProductCodes() // 加载产品编码列表
  await fetchProducts()
})

onBeforeUnmount(() => {
  if (chartInstance) {
    chartInstance.dispose()
    chartInstance = null
  }
  window.removeEventListener('resize', handleChartResize)
})
</script>

<style scoped>
.admin-plugin-container {
  padding: 20px;
  margin: 0 auto;
}

.card {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: nowrap;
}

.action-buttons {
  display: flex;
  align-items: center;
}

/* 表格区域样式 */
.table-area {
  padding: 10px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.table-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-title i {
  color: #409eff;
}

.total-count {
  font-size: 14px;
  font-weight: normal;
  color: #6b7280;
  margin-left: 8px;
}

.table-actions {
  display: flex;
  gap: 8px;
}

/* 描述列样式 */
.description-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  width: 100%;
}

/* 上传组件样式 */
.icon-upload,
.plugin-upload {
  width: 100%;
}

.el-upload__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  line-height: 1.4;
}

.icon-preview {
  margin-top: 10px;
  text-align: center;
}

.icon-actions {
  margin-top: 5px;
  display: flex;
  justify-content: center;
  gap: 5px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
}

/* 上传进度条样式 */
.upload-progress {
  margin-top: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.progress-text {
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  color: #666;
}

.success-text {
  color: #67c23a;
  font-weight: bold;
  margin-left: 8px;
}

/* 图表容器样式 */
.chart-container {
  position: relative;
  min-height: 400px;
}

:deep(.el-dialog__body) {
  padding: 20px;
}

/* 分页样式 */
.pagination-container {
  padding-top: 10px;
  display: flex;
  justify-content: center;
}

/* 动画效果 */
:deep(.el-table__row:hover) {
  background-color: #f8fafc;
}

:deep(.el-table__body tr.hover-row>td) {
  background-color: #f8fafc !important;
}

/* 滚动条样式 */
:deep(.el-table__body-wrapper::-webkit-scrollbar) {
  width: 6px;
  height: 6px;
}

:deep(.el-table__body-wrapper::-webkit-scrollbar-track) {
  background: #f1f1f1;
  border-radius: 3px;
}

:deep(.el-table__body-wrapper::-webkit-scrollbar-thumb) {
  background: #c1c1c1;
  border-radius: 3px;
}

:deep(.el-table__body-wrapper::-webkit-scrollbar-thumb:hover) {
  background: #a8a8a8;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .admin-plugin-container {
    padding: 15px;
  }

  .search-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .action-buttons {
    justify-content: center;
  }

  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .table-actions {
    align-self: flex-end;
  }
}
</style>


<style>
/* 全局样式，会作用于所有 custom-description-tooltip 类名的元素 */
.custom-description-tooltip {
  max-width: 300px !important;
  min-width: 200px !important;
  word-break: break-word !important;
  white-space: normal !important;
  line-height: 1.5 !important;
  font-size: 13px !important;

  /* 新增背景色和字体颜色设置 */
  background-color: #2d3748 !important;  /* 深色背景 */
  border-color: #2d3748 !important;      /* 边框颜色与背景一致 */
  color: #ffffff !important;             /* 白色文字 */
}

/* 设置 tooltip 内容区域的样式 */
.custom-description-tooltip .el-tooltip__popper__content {
  color: #ffffff !important;  /* 确保内容文字也是白色 */
}

/* 设置箭头颜色 */
.custom-description-tooltip .el-popper__arrow::before {
  background-color: #2d3748 !important;  /* 箭头背景色与 tooltip 一致 */
  border-color: #2d3748 !important;      /* 箭头边框色与 tooltip 一致 */
}
</style>